<template>
  <router-view style="width: 100%;"></router-view>
</template>

<script>
  export default {
    name: "Arcadia",
    data: function () {
      return {
        url: ''
      }
    },
    computed: {
      route() {
        return this.$route.name
      }
    },
  }
</script>

<style scoped>

</style>
